module.exports = __webpack_public_path__ + "static/poster_sp_en-a43d6012730ac8eb4bf6831c68ca55ee.png";